import React from 'react'
import {BollingerSeries, LineSeries} from 'react-stockcharts/lib/series'
import {schemeCategory10} from 'd3-scale'
import uniqid from 'uniqid'

import {Tooltip} from '../Tooltip'

const bbStroke = {
  top: '#964B00',
  middle: '#000000',
  bottom: '#964B00',
}
const bbFill = '#4682B4'

export const Indicators = ({indicators, showModal, gridWidth, marginTop}) => (
  indicators.map((indicator, index) => {
    const {syntax} = indicator
    const tooltip = Tooltip({
      indicator,
      showModal,
      gridWidth,
      marginTop,
      index
    })
    let series = getSeries(index, syntax)

    return(
      <g key={uniqid()}>
        {series}
        {tooltip}
      </g>
    )
  })
)

const getSeries = (index, syntax) => {
  switch(syntax) {
  case 'bb':
    return <BollingerSeries yAccessor={d => d.bb} stroke={bbStroke} fill={bbFill}/>
  default:
    return <LineSeries yAccessor={d => d[syntax]} stroke={schemeCategory10[index]}/>
  }
}
